import {createPlugin, createRoutableExtension,} from '@backstage/core-plugin-api';

import {rootRouteRef} from './routes';

export const pequiDashboardPlugin = createPlugin({
    id: 'pequi-dashboard',
    routes: {
        root: rootRouteRef,
    },
});

export const PequiDashboardPage = pequiDashboardPlugin.provide(
    createRoutableExtension({
        name: 'PequiDashboardPage',
        component: () =>
            import('./components').then(m => m.PequiDashboardPage),
        mountPoint: rootRouteRef,
    }),
);
